<template>
    <div class="amend">
        <div class="title-bar">
            <img src="//images.jinku.com/newjk/org/images/personal/personal_01.jpg" alt="" style="width: .19rem;
            height: .34rem;" @click="fanhui">
            <strong style="font-size: .36rem;">修改密码</strong>
        </div>
        <div class="cont">
            <div class="import">
                <span>原密码</span><input :type=pwdType v-model.trim="oldPwd">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_check.png" alt="" style="width: .31rem;height: .2rem;margin-right: .1rem;" v-if="pwdShow" @click="concealPwd">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_conceal.png" alt="" style="width: .31rem;height: .2rem;" v-if="!pwdShow" @click="checkPwd">
            </div>
            <div class="import">
                <span>新密码</span><input :type=newPwdType v-model.trim="newPwd">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_check.png" alt="" style="width: .31rem;height: .2rem;margin-right: .1rem;" v-if="newPwdShow" @click="concealNewPwd">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_conceal.png" alt="" style="width: .31rem;height: .2rem;" v-if="!newPwdShow" @click="checkNewPwd">
            </div>
            <p class="err" style="width: 6.07rem;margin: auto;color: red;" v-if="errShow">{{errMsg}}</p>

        </div>
        <div style="width: 100%;text-align: center;margin-top: .7rem;">
            <button class="lon" @click="savePwd">保存</button>
        </div>
    </div>
</template>

<script>
    import http from "../../lib/http";
    import common from "../../lib/common";

    export default{
        name:'amend',
        data(){
            return{
                pwdType:"password",
                newPwdType:"password",
                pwdShow:false,
                newPwdShow:false,
                errShow:false,
                errMsg:'',
                oldPwd:'',
                newPwd:'',

            }
        },
        methods:{
            checkPwd(){
              this.pwdShow = true;
              if(this.pwdShow == true){
                  this.pwdType = "text";
              }
            },
            concealPwd(){
                this.pwdShow = false;
                if(this.pwdShow == false){
                    this.pwdType = "password"
                }
            },
            checkNewPwd(){
                this.newPwdShow = true;
                if(this.newPwdShow == true){
                    this.newPwdType = "text"
                }
            },
            concealNewPwd(){
                this.newPwdShow = false;
                if(this.newPwdShow == false){
                    this.newPwdType = "password"
                }
            },
            fanhui(){
                this.$router.push('/personal');
            },
            savePwd:function () {
                if (this.oldPwd == '' || this.newPwd == ''){
                    this.errMsg = '密码不能为空';
                    this.errShow = true;
                    return false;
                }
                let that = this;
                http({
                    method: "post",
                    url: "/user/up-pwd",
                    data: "old_pwd="+encodeURIComponent(this.oldPwd)+'&new_pwd='+encodeURIComponent(this.newPwd)+'&confirm_pwd='+encodeURIComponent(this.newPwd),
                }).then(function(res){
                    if(res.code == 0){
                        that.$router.push('/prosperity');
                    }else{
                        that.errMsg = res.mess;
                        that.errShow = true;
                    }
                }).catch(function(err){

                });
            }
        }
    }
</script>

<style scoped>
    .title-bar {
        position: relative;
        text-align: center;
        margin-top: .36rem;
        margin-bottom: .27rem;
        padding-bottom: .3rem;
        border-bottom: .01rem solid #E6E6E6;
    }

    .title-bar img,
    .title-bar strong {
        vertical-align: middle;
    }

    .title-bar img {
        position: absolute;
        left: .3rem;
        top: 20%;
    }
    .import{
        width: 6.07rem;
        height: .99rem;
        display: flex;
        align-items: center;
        margin: auto;
        font-size: .24rem;
        border-bottom: .01rem solid #E6E6E6;

    }
    .import span{
        padding-right: .6rem;
        font-weight: bold;
        width: 1.7rem;
    }
    .import input{
        border: none;
        border-left: .01rem solid #E6E6E6;
        padding-left: .3rem;
        color: #333333;
    }
    .lon{
        width: 6.06rem;
        height: .78rem;
        color: white;
        font-size: .28rem;
        line-height: .78rem;
        text-align: center;
        background: #087AFE;
        border-radius: .03rem;
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/personal/amend.vue